import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { RacecardRaceRouteType } from 'src/domains/layouts/state/router/newRouter/mainRouteTypes';
import {
    CardFooterListItem,
    ShowMoreArrowWrapper,
    ShowMoreLink,
} from 'src/domains/sportsbook/webview/components/raceSliderItemV1/shared/cardFooter/CardFooter.style';

export interface CardFooterPropsType {
    routingData: RacecardRaceRouteType;
}

export const CardFooter = observer('CardFooter', (props: CardFooterPropsType) => {
    const { routingData } = props;

    return (
        <CardFooterListItem>
            <ShowMoreLink to={routingData}>
                <I18n
                    langKey='events.racebox.view.label'
                    defaultText='View racecard'
                />
                <ShowMoreArrowWrapper position='right' />
            </ShowMoreLink>
        </CardFooterListItem>
    );
});
